import { create } from 'zustand';
import { appApi } from '../api/appApi';
import type { MeResponse } from '../api/types';
import { resetDataToken } from './dataToken';

type Status = 'loading' | 'signed-out' | 'signed-in' | 'error';

interface SessionState {
  status: Status;
  me: MeResponse | null;
  error: string | null;
  load: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useSession = create<SessionState>()((set) => ({
  status: 'loading',
  me: null,
  error: null,
  async load() {
    set({ status: 'loading', error: null });
    try {
      const me = await appApi.getMe();
      set(me ? { status: 'signed-in', me } : { status: 'signed-out', me: null });
    } catch (e) {
      set({ status: 'error', error: e instanceof Error ? e.message : String(e) });
    }
  },
  async logout() {
    try {
      await appApi.logout();
    } finally {
      resetDataToken();
      set({ status: 'signed-out', me: null });
    }
  },
}));
